import { Component, inject } from '@angular/core';
import { Params, RouterModule } from '@angular/router';
import { EntityRouteService } from '@wdx/clmi/utils/services';
import {
    ENTITY_ROUTE_MAP,
    PartyStub,
    TranslationsService,
    URL_UNIMPLEMENTED,
} from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OpenInNewTabService } from '../../../../services';

@Component({
    selector: 'clmi-reference-cell-renderer',

    imports: [RouterModule],
    templateUrl: 'reference-cell-renderer.component.html',
    host: { class: 'd-flex h-100 align-items-center' },
})
export class ReferenceCellRendererComponent implements ICellRendererAngularComp {
    private entityRouteService = inject(EntityRouteService);
    private translationsService = inject(TranslationsService);
    private openInNewTabService = inject(OpenInNewTabService);

    public items: { routerLink?: string[]; queryParams?: Params; name }[];

    agInit(params: ICellRendererParams<any, PartyStub | PartyStub[]>): void {
        const unimplemented = URL_UNIMPLEMENTED.join();
        const valueArray = Array.isArray(params.value)
            ? params.value.map((x) => x)
            : params.value
              ? [params.value]
              : [];
        this.items = valueArray?.map(({ name, type, id }) => {
            const route =
                type && id && ENTITY_ROUTE_MAP[type]?.join() !== unimplemented
                    ? this.entityRouteService.routeWithParamsForEntity(type, id)
                    : undefined;

            const routerLink = route ? route.routerLink : undefined;
            const queryParams = route ? route.queryParams : undefined;
            return {
                name: this.translationsService.translateTokenisedString(name),
                routerLink,
                queryParams,
            };
        });
    }

    refresh(params: ICellRendererParams): boolean {
        this.agInit(params);
        return true;
    }

    linkClicked(
        event: Event,
        item: { routerLink?: string[]; queryParams?: Params; name },
    ) {
        event.stopPropagation();
        this.openInNewTabService.openURLInNewTab(item.routerLink?.join('/'));
    }
}
